import React, { useState, useMemo, useEffect } from "react";
// react plugin used to create DropdownMenu for selecting items
import Select from 'react-select'
import './SelectApp.css'

const SelectApp = (props) => {
  const [value, setValue] = useState()
  const [options, setOptions] = useState([])
  const plan = props.plan
  const setPlan = props.setPlan

  const changeHandler = item => {
    setValue(item)
    plan['app'] = item.value
    setPlan(plan)
  }

  useEffect(() => {

    let alternatives = []

    props.selectOptions?.map((item) => {
      let target = { value: item._id, label: item.name }

      alternatives.push(target)

      if (item._id == plan.app?._id){
        setValue(target)
      }

    })

    setOptions(alternatives)    

  }, [props.selectOptions])

  return (
    <div >
      <Select
        className="form-control-alternative"
        isDisabled={props.formDisabled}
        options={options}
        value={value}
        id="input-app"
        classNamePrefix="selectApp"
        onChange={changeHandler}
      />
    </div>
  );

}

export default SelectApp;
